import { Main } from './components/containers/Main';

const Batches = () => <Main />;

export default Batches;
